import { render } from "./tab-list.vue?vue&type=template&id=43df7a29&scoped=true&ts=true"
import script from "./tab-list.vue?vue&type=script&lang=ts"
export * from "./tab-list.vue?vue&type=script&lang=ts"

import "./tab-list.vue?vue&type=style&index=0&id=43df7a29&lang=scss&scoped=true"

import exportComponent from "/Users/panren/Desktop/太平洋网络/discount-topics-wap-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43df7a29"]])

export default __exports__